var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdgeUsageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hub_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_854",
    "data-name": "Rectangle 854",
    width: 30,
    height: 30,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M10.5,22.948a3.744,3.744,0,1,1-3-1.513,3.7,3.7,0,0,1,1.538.328L10.8,19.531a5.713,5.713,0,0,1-1.363-4.653L6.9,14.021a3.781,3.781,0,1,1,.6-2.043,1.878,1.878,0,0,1-.013.265l2.537.857a5.589,5.589,0,0,1,4.025-2.925V7.452a3.8,3.8,0,0,1-2.8-3.669,3.75,3.75,0,1,1,4.688,3.669v2.723A5.589,5.589,0,0,1,19.962,13.1l2.538-.857v-.265a3.767,3.767,0,1,1,.6,2.055l-2.538.857A5.7,5.7,0,0,1,19.2,19.543l1.762,2.232a3.52,3.52,0,0,1,1.538-.34,3.77,3.77,0,1,1-3,1.513l-1.762-2.232a5.581,5.581,0,0,1-5.463,0Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdgeUsageIcon);
export default __webpack_public_path__ + "static/media/EdgeUsageIcon.b1c128c21d6afd5d2299c9946ed76be3.svg";
export { ForwardRef as ReactComponent };